import packageInfo from '../../package.json';

export const environment = {
  production: true,
  beta: false,
  VERSION: packageInfo.version,
  url: {
    bff: 'https://bff-backend.einsatzwetter.de',
    bffV2: 'https://bff-backendv2.einsatzwetter.de',
    bffV3: 'https://bff.v3.einsatzwetter.de',
    // op-reports (Einsatzprotokoll) – eigener "intern" BFF, siehe
    // operational-report.service.ts.
    bffV3Intern: 'https://bff-intern.v3.einsatzwetter.de',
    bffInternBETranslations:
      'https://wm-translations.s3.eu-west-1.amazonaws.com/',
    mapServer: 'https://mapserver.metops.net',
    mapServerApi: 'https://mapserver-api.metops.net',
    dataArchive: 'https://data.einsatzwetter.de',
    dataArchiveProxy: 'https://data.einsatzwetter.de',
    sendMan:
      'https://cors-anywhere.herokuapp.com/jgm7guphn5.execute-api.eu-west-1.amazonaws.com/dev/',
    userAdmin: 'https://bff-backendv2.einsatzwetter.de',
  },
  raygun: {
    apiKey: 'WhTk5DXzhEnyvPn2rrxiw',
  },
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiY29ubnlicnVobiIsImEiOiJjanBqaHU2aWMwNmY0M3FsdjVyaXo0N21lIn0.wOrequAwl4sj8xvEzP5_6A',
    url: 'https://api.mapbox.com',
    layers: [
      {
        name: 'radar',
        style: 'connybruhn/ckcyi11261klk1iqvvrqowu4b',
      },
      {
        name: 'street',
        style: 'connybruhn/ckmb16v2ejg2h17lji448usbr',
      },
      {
        name: 'sat',
        style: 'connybruhn/ckmbuv4ph3bhn17ql98o3b4st',
      },
    ],
  },
  afterLogoutUrl: {
    de: 'https://www.meteofocus.com/',
    nl: 'https://www.meteofocus.com/',
    fr: 'https://www.meteofocus.com/',
    us: 'https://www.meteofocus.com/',
  },
};
